export default {
  getCurrencyItem: (state) => state.currencyItem,
};
